<template>
  <div>
    <div class="input-group search-bar mb-3 p-0">
      <div class="input-group-prepend">
        <span class="input-group-text pr-0">
          <img class="mr-2" src="@/assets/searchIcon.svg" />
        </span>
      </div>
      <input
        class="form-control border-left-0"
        placeholder="Search gst number"
        v-model="partnerDetailsFilterText"
        @keydown="clickedSearch"
        @keyup="clickedSearch"
      />
    </div>
    <br />
    <div class="card-background">
      <w-collapse-table
        :tableProperties="gstTableDataList"
        :tableLoading="showTableLoding"
        :filter="partnerDetailsFilterText"
        :typeOfTable="'gstTableSummary'"
        @getPoNumber="goToPoWoDetails($event)"
        @openGstModal="triggerEditGstModal($event)"
      />
    </div>
  </div>
</template>

<script>
import { SummaryServices } from "../../services/summaryService";
const SummaryService = new SummaryServices();

import TextInput from "../../widgets/TextInput.vue";
import DropDown from "../../widgets/DropDown";
import Datepicker from "../../widgets/DatePicker";
import DatePicker from "vue2-datepicker";
import partnertable from "../../widgets/partner-table-collapsable";
export default {
  props: ["answerNumber"],
  components: {
    "w-text-input": TextInput,
    "w-drop-down": DropDown,
    "w-datepicker": Datepicker,
    "w-collapse-table": partnertable,
    DatePicker
  },
  data() {
    return {
      enableSubmit: true,
      partnerDetailsFilterText: "",
      gstTableDataList: {
        fields: [
          {
            key: "typeOfRegistration",
            label: "Registration Type",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "state",
            label: "State",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "gstinNumber",
            label: "Gst Number",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "thresholdTurnoverLimit",
            label: "Threshold Limit",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "gstRegistrationDate",
            label: "Registration Date",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "gstGstEffectiveDate",
            label: "GSt Effective Period",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "gstDocumentId",
            label: "GST Attachment",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "dealerType",
            label: "Delear Type",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "toggle_icon",
            label: "",
            thClass: "thClassCenter",
            tdClass: "text-center"
          }
        ],
        items: []
      }
    };
  },
  watch: {},
  created() {
    this.getGstDetails();
  },
  computed: {},
  methods: {
    getGstDetails() {
      SummaryService.getGstDetails(this.answerNumber).then(resp => {
        this.gstTableDataList.items = resp.response;
      });
    },
    clickedSearch(event) {
      this.partnerDetailsFilterText = this.partnerDetailsFilterText.toUpperCase();
      console.log(event);
    }
  }
};
</script>

<style scoped>
.card-background {
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
}
.search-bar .input-group-prepend .input-group-text {
  height: 38px;
  border-radius: 0;
  font-family: "Source Sans Pro", sans-serif;
  border: 1px solid #ced4da;
  background: #f4f4f4;
  font-size: 15px;
  cursor: pointer;
}

.search-bar .form-control {
  height: 38px;
  width: 30px !important;
  border-radius: 0;
  border: 1px solid #ced4da;
  font-size: 18px;
  font-family: "Source Sans Pro", sans-serif;
}

.search-bar .form-control:focus {
  box-shadow: none;
}
.search-bar {
  width: 30% !important;
}
.add-gst-button {
  background-color: #0e5d84;
  font-size: 14px;
  font-weight: 600;
  border-color: none !important;
  width: 130px !important;
}
.sumbit-approval {
  background-color: #0e5d84;
  font-size: 14px;
  font-weight: 600;
  border-color: none !important;
}
.save-gst-button {
  background-color: #0e5d84;
  font-size: 14px;
  font-weight: 500;
  border-color: none !important;
  color: #ffffff !important;
  width: 164px;
  /* width: 130px !important; */
}
.save-gst-button:disabled {
  cursor: not-allowed;
}
.partner-reg {
  font-family: "Source Sans Pro", sans-serif !important;
  font-size: 15px;
  text-align: left;
  color: #696969;
}
.partner-reg-subText {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: bold;
  text-align: left;
  color: #212529;
}
</style>
<style>
.custom-control-input:checked ~ .custom-control-label > span {
  font-family: "Source Sans Pro", sans-serif !important;
  font-size: 15px !important;
  font-weight: bold;
  text-align: left;
  color: #002d72 !important;
}
.custom-control-input ~ .custom-control-label > span {
  font-family: "Source Sans Pro", sans-serif !important;
  font-size: 15px !important;
  /* font-weight: bold; */
  text-align: left;
  /* color: #002d72 !important; */
}
.thClassLeft {
  background-color: #6192b1;
  color: white;
  text-align: left !important;
}
.thClassright {
  background-color: #6192b1;
  color: white;
  text-align: right !important;
}

.thClassCenter {
  background-color: #6192b1;
  color: white;
  text-align: center !important;
}
</style>